<script setup>
import { computed } from "vue";

const props = defineProps({
    serviceDetail: Array,
});

const parseHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    return Array.from(tempDiv.childNodes)
        .filter((node) => node.nodeType === 1)
        .map((node) => ({
            tag: node.nodeName.toLowerCase(),
            content: node.innerHTML,
            isList: node.nodeName.toLowerCase() === "ul"
        }));
};

const processedDescriptions = computed(() =>
    props.serviceDetail.map((item) => ({
        parsedContent: parseHtml(item.description),
    }))
);
</script>

<template>
    <template v-for="(item, index) in processedDescriptions" :key="index">
        <template v-for="(element, idx) in item.parsedContent" :key="idx">
            <component
                :is="element.tag"
                v-html="element.content"
                :class="{
                    'text-[14px] md:text-primary text-grayBlackColor font-normal font-hanuman-sans leading-7 md:leading-[30px]': element.tag === 'p', // tag p
                    'text-title-content-sub font-kantumruy-pro-hanuman-sans leading-7 md:leading-[45px]': element.tag === 'h1', // tag h1
                    'text-title-content-sub font-kantumruy-pro-hanuman-sans leading-7 md:leading-[45px]': element.tag === 'h2', // tag h2
                    'tag-ul list-disc pl-10 space-y-0 md:space-y-1 leading-7 md:leading-[30px]': element.tag === 'ul' // tag ul
                }"
            >
            </component>
        </template>
    </template>
</template>
